<template>
  <div class="controlManagement-page" v-allow="'080203'" style="width: 100%">
    <div class="all-content-container">
      <div class="table-content-container">
        <div class="table-title-container">
          <div class="table-title-title">
            <h4>控制设备</h4>
            <router-link to="addControlManagement">
              <el-button type="primary" class="addBtn">添加</el-button>
            </router-link>
          </div>
          <div class="table-content-title">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="设备名称：">
                <el-input v-model="name" placeholder="请输入设备名称" maxlength="20" clearable></el-input>
              </el-form-item>
              <el-form-item label="设备编码：">
                <el-input v-model="code" placeholder="请输入设备编码" maxlength="20" clearable></el-input>
              </el-form-item>
              <el-form-item label="所属分组：">
                <el-cascader @change="changeTreeItem" :show-all-levels="false" v-model="groupId" :options="departList"
                  :props="optionProps" clearable placeholder="请选择所属分组"></el-cascader>
              </el-form-item>
              <el-form-item class="mar-l">
                <el-button type="primary" @click="onSubmit">查询</el-button>
                <el-button @click="resetonSubmit">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table-content">
          <div class="table-table">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#f4f5f7' }">
              <el-table-column align="center" label="序号" width="95">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="name" label="设备名称" align="center"></el-table-column>
              <el-table-column prop="code" label="设备编码" align="center"></el-table-column>
              <el-table-column prop="groupName" label="所属分组" align="center"></el-table-column>
              <el-table-column prop="gatewayName" label="所属网关" align="center"></el-table-column>
              <!-- <el-table-column
                prop="switchType"
                label="开关分类"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.switchType | switchType }}</span>
                </template>
              </el-table-column> -->
              <el-table-column prop="isOpen" label="工作状态" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.isOpen == 0">
                    <span class="show-line show-rline"></span>
                    停用
                  </div>
                  <div v-if="scope.row.isOpen == 1">
                    <span class="show-line show-bline"></span>

                    启用
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="300px">
                <template slot-scope="scope">
                  <el-button type="text" :underline="false" size="small" @click="edit(scope.row.id)">编辑</el-button>
                  <el-button type="text" :underline="false" size="small" @click="deletes(scope.row.id)">删除</el-button>
                  <el-button type="text" :underline="false" size="small" v-if="scope.row.isOpen == 1"
                    @click="onOrOffNumericalBth4(scope.row.id)">停用</el-button>
                  <el-button type="text" :underline="false" size="small" v-if="scope.row.isOpen == 0"
                    @click="onOrOffNumericalBth5(scope.row.id)">启用</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="pagination-container">
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap"
              @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize"
              :total="total"></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      input: "",
      input1: "",
      input2: "",
      currentPage: 1,
      pagesize: 8,
      code: "",
      groupId: "",
      name: "",
      total: 0,
      departList: [],
      tableData: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        checkStrictly: true,
      },
    };
  },
  created() {
    this.getSwitchList();
    this.getConfigGroupTree();
  },
  methods: {
    //i所属分组id
    changeTreeItem(val) {
      this.groupId = val[val.length - 1];
    },

    //清除
    empty() {
      this.code = ""; //设备编码
      this.groupId = ""; // 分组id
      this.name = ""; //名称
    },
    //  重置
    resetonSubmit() {
      this.empty();
      this.onSubmit();
    },
    //查询
    onSubmit() {
      this.getSwitchList();
    },
    //分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getSwitchList();
    },
    //查询设备分组树，查询1
    getConfigGroupTree() {
      this.$api.system
        .getConfigGroupTree(
          0, //主键id ，根据具体业务进行判定
        )
        .then((res) => {
          if (res.code == 200) {
            this.departList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //删除
    deletes(id) {
      this.$confirm("是否删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.system
            .delfun(`/pc/objDeviceSwitch/delSwitch`, id)
            .then((res) => {
              if (res.code == 200) {
                this.getSwitchList();
                this.$message({
                  type: "success",
                  message: res.msg,
                });
              } else {
                // this.$message.error(res.msg)
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    //启用/停用
    onOrOffNumericalBth5(id) {
      this.$confirm("是否启用？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.openOrCloseSwitch(id);
        })
        .catch(() => {
          this.$message.info("已取消启用");
        });
    },
    onOrOffNumericalBth4(id) {
      this.$confirm("是否停用？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.openOrCloseSwitch(id);
        })
        .catch(() => {
          this.$message.info("已取消停用");
        });
    },
    //启用/停用 接口id
    openOrCloseSwitch(id) {
      this.$api.system
        .openOrCloseSwitch(id)
        .then((res) => {
          if (res.code == 200) {
            this.getSwitchList();
            this.$message({
              type: "success",
              message: res.msg,
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 编辑
    edit(id) {
      this.$router.push({
        path: "addControlManagement",
        query: {
          id: id,
        },
      });
    },
    //添加
    addVideo() {
      this.$router.push({
        path: "addControlManagement",
        query: {},
      });
    },
    // 查询控制设备列表
    getSwitchList() {
      this.$api.system
        .getSwitchList(
          this.currentPage, //第几页，默认1
          this.pagesize, //默认展示多少条，默认10
          this.code, //设备编码
          this.groupId, // 分组id
          this.name //名称
        )
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/controlManagement.scss";
</style>